/* SIXAMPM — Warenkorb-Schublade (Neubau 17.09.2026).
 *
 * Markup: snippets/cart-drawer.liquid. Die öffentliche Schnittstelle ist die
 * von Dawn, weil product-form.js, sx2-pdp-main und sx2-cart.js sie aufrufen:
 *   open(trigger), close(), renderContents(response),
 *   getSectionsToRender(), setActiveElement(el), Klasse `is-empty`.
 *
 * Alle Änderungen laufen über die Cart-AJAX-API mit `sections`, damit Summen,
 * Versandbalken und Header-Zähler aus derselben Antwort kommen. Nichts wird
 * lokal gerechnet. Ereignisse sind am Element delegiert — #CartDrawer wird bei
 * jedem Update ersetzt, einzeln gebundene Listener gingen dabei verloren.
 */
(function () {
  'use strict';
  if (customElements.get('cart-drawer')) return;

  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  // Wer die Schublade AUF der Warenkorbseite benutzt, aendert dieselben Daten
  // zweimal auf einem Bildschirm. Bis 20.09.2026 lud die Seite daraufhin neu
  // und die Schublade klappte mitten im Bedienen zu (gemessen). Deshalb holt
  // die Schublade die beiden Sections der Seite gleich mit und malt sie mit.
  function seitenSections() {
    var ids = SECTIONS.slice();
    var liste = document.querySelector('.sx2-cart[data-section-id]');
    var summe = document.querySelector('[data-sx2-cart-footer]');
    if (liste) ids.push(liste.dataset.sectionId);
    if (summe) ids.push(summe.dataset.sectionId);
    return ids;
  }
  var ERROR_TEXT = 'Der Warenkorb konnte gerade nicht aktualisiert werden. Bitte prüfe deine Verbindung und versuche es erneut.';

  function routes() {
    var r = window.routes || {};
    return {
      add: (r.cart_add_url || '/cart/add') + '.js',
      change: (r.cart_change_url || '/cart/change') + '.js',
      cart: r.cart_url || '/cart'
    };
  }

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      if (this.dataset.sx2Bound) return;
      this.dataset.sx2Bound = '1';
      this.pending = false;
      this.lastRemoved = null;

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.classList.contains('active')) {
          event.preventDefault();
          this.close();
        }
      });
      this.addEventListener('submit', (event) => {
        if (!event.target.matches('[data-sx2-dr-form]')) return;
        var button = event.target.querySelector('[name="checkout"]');
        if (button) button.setAttribute('aria-busy', 'true');
      });

      this.bindHeaderLink();

      // Im Theme-Editor rendert Shopify den Header neu; der Warenkorb-Link ist
      // danach ein anderes Element und traegt die Bindung nicht mehr.
      document.addEventListener('shopify:section:load', () => this.bindHeaderLink());

      // Zurück aus dem Checkout: der Browser zeigt die Seite aus dem Cache,
      // Zähler und Schublade stünden auf dem alten Stand.
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) this.refresh();
      });
    }

    bindHeaderLink() {
      var link = document.getElementById('cart-icon-bubble');
      if (!link || link.dataset.sx2Drawer) return;
      link.dataset.sx2Drawer = '1';
      link.setAttribute('role', 'button');
      link.setAttribute('aria-haspopup', 'dialog');
      link.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(link);
      });
      link.addEventListener('keydown', (event) => {
        if (event.code === 'Space') {
          event.preventDefault();
          this.open(link);
        }
      });
    }

    /* --- Dawn-Schnittstelle -------------------------------------------- */

    getSectionsToRender() {
      // Dawn liest hier nur `id`. Der Selektor bleibt fuer product-form stehen.
      return seitenSections().map((id) => (id === 'cart-drawer' ? { id: id, selector: '#CartDrawer' } : { id: id }));
    }

    setActiveElement(element) {
      this.activeElement = element;
    }

    renderContents(response) {
      this.lastRemoved = null;
      if (!this.paint(response && response.sections)) {
        this.refresh().then(() => this.open());
        return;
      }
      this.announce('Artikel wurde in den Warenkorb gelegt.');
      this.open();
    }

    open(trigger) {
      if (trigger) this.setActiveElement(trigger);
      if (this.classList.contains('active')) {
        this.focusPanel();
        return;
      }
      var gap = window.innerWidth - document.documentElement.clientWidth;
      if (gap > 0) document.body.style.paddingRight = gap + 'px';
      document.body.classList.add('overflow-hidden');
      requestAnimationFrame(() => this.classList.add('active'));
      setTimeout(() => this.focusPanel(), reducedMotion() ? 0 : 320);
    }

    close() {
      if (!this.classList.contains('active')) return;
      this.classList.remove('active');
      this.lastRemoved = null;
      var undo = this.querySelector('[data-sx2-dr-undo]');
      if (undo) undo.hidden = true;
      document.body.classList.remove('overflow-hidden');
      document.body.style.paddingRight = '';
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
      else if (this.activeElement) this.activeElement.focus();
    }

    /* --- Ereignisse ---------------------------------------------------- */

    onClick(event) {
      var target = event.target;
      if (target.closest('[data-sx2-dr-close]')) {
        event.preventDefault();
        this.close();
        return;
      }
      if (this.pending) {
        if (target.closest('button')) event.preventDefault();
        return;
      }
      var undo = target.closest('[data-sx2-dr-undo-btn]');
      if (undo) {
        event.preventDefault();
        this.undo();
        return;
      }
      var add = target.closest('[data-sx2-dr-add]');
      if (add) {
        event.preventDefault();
        this.add(Number(add.dataset.sx2DrAdd), 1, add.dataset.title, add);
        return;
      }
      var item = target.closest('[data-sx2-dr-item]');
      if (!item) return;
      var input = item.querySelector('[data-sx2-dr-qty]');
      if (target.closest('[data-sx2-dr-remove]')) {
        event.preventDefault();
        this.change(item, 0);
        return;
      }
      var step = target.closest('[data-sx2-dr-step]');
      if (step && input) {
        event.preventDefault();
        var increment = Number(input.step) || 1;
        var quantity = Number(input.value) + Number(step.dataset.sx2DrStep) * increment;
        if (quantity < Number(input.dataset.min || 1)) quantity = 0;
        this.change(item, quantity);
      }
    }

    onChange(event) {
      var input = event.target;
      if (!input.matches('[data-sx2-dr-qty]')) return;
      var item = input.closest('[data-sx2-dr-item]');
      var raw = input.value.trim();
      var quantity = raw === '' ? NaN : Number(raw);
      var min = Number(input.dataset.min || 1);
      var increment = Number(input.step) || 1;
      var max = input.max === '' ? Infinity : Number(input.max);
      // Shopify zählt Schritte ab dem Minimum: min 5, Schritt 10 → 5, 15, 25.
      var valid = Number.isSafeInteger(quantity) && quantity >= 0 &&
        (quantity === 0 || (quantity >= min && quantity <= max && (quantity - min) % increment === 0));
      if (!valid) {
        input.value = input.dataset.originalQuantity;
        this.showItemError(item, 'Bitte gib eine gültige Menge ein.');
        return;
      }
      if (String(quantity) === input.dataset.originalQuantity) return;
      this.change(item, quantity);
    }

    /* --- Anfragen ------------------------------------------------------ */

    async change(item, quantity) {
      var key = item.dataset.key;
      var input = item.querySelector('[data-sx2-dr-qty]');
      var before = input ? Number(input.dataset.originalQuantity) : 0;
      var removing = quantity === 0;
      var data = await this.send(routes().change, { id: key, quantity: quantity }, item);
      if (!data) {
        if (input) input.value = input.dataset.originalQuantity;
        return;
      }

      if (removing) {
        this.lastRemoved = { id: Number(item.dataset.variantId), quantity: before, title: item.dataset.title };
        this.showUndo();
        this.announce('„' + item.dataset.title + '" wurde entfernt.');
        this.focusAfter(null);
      } else {
        var line = (data.items || []).find((row) => row.key === key);
        var fresh = this.findItem(key);
        if (line && line.quantity !== quantity && fresh) {
          this.showItemError(fresh, 'Es sind nur ' + line.quantity + ' Stück verfügbar.');
        }
        this.announce('Menge aktualisiert.');
        this.focusAfter(key);
      }
    }

    async add(variantId, quantity, title, button) {
      if (!Number.isSafeInteger(variantId) || variantId <= 0) return;
      if (button) button.setAttribute('aria-busy', 'true');
      var data = await this.send(routes().add, { items: [{ id: variantId, quantity: quantity }] }, null);
      if (!data) return;
      this.announce('„' + (title || 'Artikel') + '" wurde hinzugefügt.');
      this.focusAfter(null);
    }

    undo() {
      var removed = this.lastRemoved;
      if (!removed) return;
      this.lastRemoved = null;
      this.add(removed.id, removed.quantity || 1, removed.title, null);
    }

    refresh() {
      var url = routes().cart + '?sections=' + seitenSections().join(',');
      return fetch(url, { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : null))
        .then((sections) => { if (sections) this.paint(sections); })
        .catch(() => {});
    }

    async send(url, payload, item) {
      if (this.pending) return null;
      this.pending = true;
      this.setBusy(true, item);
      this.clearErrors();
      payload.sections = seitenSections();
      payload.sections_url = window.location.pathname;
      var data = null;
      try {
        var response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(payload)
        });
        var json = await response.json();
        if (!response.ok || json.status) {
          // Nur Ablehnungen des Servers sind vorzeigbar (z. B. Bestand).
          // Netzfehler tragen englische Browsertexte.
          var rejection = new Error(json.description || json.message || ERROR_TEXT);
          rejection.fromServer = true;
          throw rejection;
        }
        data = json;
        if (!this.paint(json.sections)) await this.refresh();
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sx2-drawer', cartData: json });
        }
      } catch (err) {
        var message = err && err.fromServer ? err.message : ERROR_TEXT;
        if (item && item.isConnected) this.showItemError(item, message);
        else this.showGlobalError(message);
        this.announce(message);
      } finally {
        this.pending = false;
        this.setBusy(false, item);
      }
      return data;
    }

    /* --- Darstellung --------------------------------------------------- */

    paint(sections) {
      if (!sections || !sections['cart-drawer']) return false;
      var fresh = parse(sections['cart-drawer']).querySelector('#CartDrawer');
      var root = this.querySelector('#CartDrawer');
      if (!fresh || !root) return false;

      var scroller = root.querySelector('[data-sx2-dr-scroll]');
      var scrollTop = scroller ? scroller.scrollTop : 0;
      root.innerHTML = fresh.innerHTML;
      var nextScroller = root.querySelector('[data-sx2-dr-scroll]');
      if (nextScroller) nextScroller.scrollTop = scrollTop;

      this.classList.toggle('is-empty', !root.querySelector('[data-sx2-dr-item]'));
      if (this.lastRemoved) this.showUndo();

      this.paintCartPage(sections);

      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && sections['cart-icon-bubble']) {
        var doc = parse(sections['cart-icon-bubble']);
        var content = doc.querySelector('.shopify-section');
        bubble.innerHTML = content ? content.innerHTML : doc.body.innerHTML;
      }
      return true;
    }

    // Liegt die Warenkorbseite offen, kommt ihr frisches Markup in derselben
    // Antwort. Sie zu ersetzen ist billiger und ruhiger als ein Seitenneuladen.
    paintCartPage(sections) {
      var gemalt = false;
      [['.sx2-cart[data-section-id]', '.sx2-cart'], ['[data-sx2-cart-footer]', '[data-sx2-cart-footer]']].forEach((paar) => {
        var ziel = document.querySelector(paar[0]);
        if (!ziel) return;
        var html = sections[ziel.dataset.sectionId];
        if (!html) return;
        var frisch = parse(html).querySelector(paar[1]);
        if (!frisch) return;
        ziel.innerHTML = frisch.innerHTML;
        ziel.className = frisch.className;
        gemalt = true;
      });
      // Die Kaufleiste der Warenkorbseite beobachtet den Kassenknopf. Nach dem
      // Austausch zeigt der Beobachter auf ein Element, das es nicht mehr gibt.
      if (gemalt) document.dispatchEvent(new CustomEvent('sx2:cart:repainted'));
    }

    setBusy(state, item) {
      this.classList.toggle('is-loading', state);
      var panel = this.querySelector('[data-sx2-dr-panel]');
      if (panel) panel.setAttribute('aria-busy', String(state));
      if (item && item.isConnected) item.classList.toggle('is-busy', state);
      if (!state) {
        this.querySelectorAll('[data-sx2-dr-add][aria-busy]').forEach((el) => el.removeAttribute('aria-busy'));
      }
    }

    showUndo() {
      var slot = this.querySelector('[data-sx2-dr-undo]');
      if (!slot || !this.lastRemoved) return;
      slot.querySelector('[data-sx2-dr-undo-text]').textContent = '„' + this.lastRemoved.title + '" entfernt.';
      var button = slot.querySelector('[data-sx2-dr-undo-btn]');
      if (button) button.hidden = false;
      slot.hidden = false;
    }

    showItemError(item, message) {
      var el = item.querySelector('[data-sx2-dr-err]');
      if (!el) return;
      el.textContent = message;
      el.hidden = false;
    }

    showGlobalError(message) {
      var slot = this.querySelector('[data-sx2-dr-undo]');
      if (!slot) return;
      this.lastRemoved = null;
      slot.querySelector('[data-sx2-dr-undo-text]').textContent = message;
      var button = slot.querySelector('[data-sx2-dr-undo-btn]');
      if (button) button.hidden = true;
      slot.hidden = false;
    }

    clearErrors() {
      this.querySelectorAll('[data-sx2-dr-err]').forEach((el) => { el.hidden = true; el.textContent = ''; });
    }

    findItem(key) {
      return Array.from(this.querySelectorAll('[data-sx2-dr-item]')).find((row) => row.dataset.key === key) || null;
    }

    focusAfter(key) {
      if (!this.classList.contains('active')) return;
      var item = key ? this.findItem(key) : null;
      var target = (item && item.querySelector('[data-sx2-dr-qty]')) ||
        (this.lastRemoved && this.querySelector('[data-sx2-dr-undo-btn]')) ||
        this.querySelector('[data-sx2-dr-panel]');
      this.focusPanel(target);
    }

    focusPanel(target) {
      var panel = this.querySelector('[data-sx2-dr-panel]');
      if (!panel) return;
      var focusTarget = target || panel;
      if (typeof trapFocus === 'function') trapFocus(panel, focusTarget);
      else focusTarget.focus();
    }

    announce(message) {
      var live = this.querySelector('[data-sx2-dr-live]');
      if (!live) return;
      live.textContent = '';
      setTimeout(() => { live.textContent = message; }, 60);
    }
  }

  customElements.define('cart-drawer', CartDrawer);
})();
